import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import { ZonePostalCodesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import {
  CustomResultOfPaginatedListOfGetZonePostalCodesWithPaginationDto,
  GetEnumValuesDto,
  GetZonePostalCodesWithPaginationDto,
  PaginatedListOfGetZonePostalCodesWithPaginationDto,
} from '../../../core/api/models';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { ZonePostalCodesFormComponent } from "./zone-postal-codes-form/zone-postal-codes-form.component";


@Component({
    selector: 'app-zone-postal-codes',
    templateUrl: './zone-postal-codes.component.html',
    imports: [BaseIndexModule, ZonePostalCodesFormComponent]
})
export class ZonePostalCodesComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.zonePostalCodes;

  /* Binding service endpoints */
  protected currentService = inject(ZonePostalCodesService);

  paginationApiMethodName: string =
    this.currentService.zonePostalCodesGetWithPagination.name;

  createGetApiMethodName: string =
    this.currentService.zonePostalCodesCreateGet.name;

  auditApiMethodName: string =
    this.currentService.zonePostalCodesGetZonePostalCodesAuditWithPagination.name;

  modelWithPagination$: Observable<PaginatedListOfGetZonePostalCodesWithPaginationDto>;
  items$: Observable<Array<GetZonePostalCodesWithPaginationDto>>;
  ZoneTypeEnumValues: GetEnumValuesDto[] = [];
  idPropertyName = 'postalCode';
  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.Update_key) {
        let splittedValue = value.toString().split('_');
        this.onUpdate(splittedValue[0], splittedValue[1], false);
      }
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('ZoneType')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.ZoneTypeEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      { title: 'common.postalCode', name: 'postalCode', hasSearch: true },
      { title: this.localizer.title, name: 'title', hasSearch: true },
      { title: 'common.area', name: 'zoneName', hasSearch: true },
      {
        title: `${this.tableVocabs}mciCount`,
        name: 'mciCount',
        hasSearch: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}mtnCount`,
        name: 'mtnCount',
        hasSearch: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}rightelCount`,
        name: 'rightelCount',
        hasSearch: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}otherCount`,
        name: 'otherCount',
        hasSearch: true,
        type: 'number',
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get ById
  baseGetByIdApi(event: any): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = event;
    this.currentService
      .zonePostalCodesUpdateGet({
        PostalCode: event.postalCode,
        ZoneId: event.zoneId,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;

    this.currentService
      .zonePostalCodesDeleteDelete({ body: { postalCode: id } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }
  //#endregion

  onUpdate(postalCode?, zoneId?, setFiltersAndUrl = true) {
    if (setFiltersAndUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Update_key +
          '=' +
          postalCode +
          '_' +
          zoneId
      );
    }
    this.formPageConfig.editData = {};
    this.formPageConfig.isEditMode = true;
    this.baseGetByIdApi({ postalCode: postalCode, zoneId: zoneId });
  }
}
